// SUPPORT-TIPP-INDIKATOR-001 — Mindestanzeige des Tipp-Indikators („schreibt…").
// Jede Assistenten-Antwort erscheint frühestens 800 ms nach dem Absenden — auch die
// lokalen Sofort-Antworten des Backends (Notfall/Geld/Mensch-Frage, < 50 ms) und
// Fehlermeldungen, sonst verrät die 0-ms-Antwort den Automaten. Die Wartezeit sitzt
// AUSSCHLIESSLICH im Client zwischen Response-Eintreffen und Anzeigen: der HTTP-Request
// wird nie künstlich gehalten, bei langsamer Antwort ist die Rest-Wartezeit 0.
// Gleicher Wert wie im Landing-Chat (voogo-landing SupportChat.tsx) — konsistent halten.

export const TYPING_MIN_VISIBLE_MS = 800;

// Rest-Wartezeit ab Absendezeitpunkt — reine Funktion, testbare Naht.
export function remainingTypingDelay(startedAt, now = Date.now(), minVisibleMs = TYPING_MIN_VISIBLE_MS) {
  const elapsed = now - startedAt;
  if (!Number.isFinite(elapsed) || elapsed < 0) return minVisibleMs;
  return Math.max(0, minVisibleMs - elapsed);
}

// Wartet die Rest-Zeit ab; bei 0 sofort erledigt (keine zusätzliche Wartezeit).
export function waitForTypingDelay(startedAt, now = Date.now()) {
  const ms = remainingTypingDelay(startedAt, now);
  if (ms <= 0) return Promise.resolve();
  return new Promise((resolve) => { setTimeout(resolve, ms); });
}
